var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('span',{staticClass:"main_title grey--text text--darken-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('br'),_c('span',{staticClass:"subtitle grey--text"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }